export function webHistoryStatus(record, date, today) {
  const missing = !record || record.synthetic || record.noAttendanceRecord;
  const sunday = new Date(`${date}T00:00:00Z`).getUTCDay() === 0;
  if (record?.holidayCredit && missing) return 'HOLIDAY';
  let status = missing ? 'NOT_MARKED' : record.presenceStatus || 'NOT_MARKED';
  if (missing && sunday) return 'WEEK_OFF';
  if (date > today && !['ON_LEAVE', 'HOLIDAY', 'WEEK_OFF'].includes(status)) return 'UPCOMING';
  const checkIn = record?.firstInAt || record?.firstIn?.time;
  const checkOut = record?.lastOutAt || record?.lastOut?.time;
  if (checkIn && (!checkOut || record.missingCheckOut)) return 'NO_CHECKOUT';
  if (status === 'NOT_MARKED' || status === 'NO_RECORD') return date <= today ? 'ABSENT' : 'UPCOMING';
  return status;
}
export const historyLabels = { PRESENT: 'Present', ABSENT: 'Absent', ON_LEAVE: 'On leave', HALF_DAY: 'Half day', WEEK_OFF: 'Sunday / Week off', HOLIDAY: 'Holiday', NO_CHECKOUT: 'No checkout', UPCOMING: 'Upcoming' };
